module.exports = __webpack_public_path__ + "static/ee2078f204623546a36922e3e4f74862c1ca334efe084197c20076fb9da75458-06a0fa6289503bfece003b616e93259d.png";